import Header from '../../container/Header'
import Main from '../../container/Main'

const Home = () => {
  document.title = 'eFood'

  return (
    <>
      <Header />
      <Main />
    </>
  )
}

export default Home
